import { render, staticRenderFns } from "./ReportsTabInvoices.vue?vue&type=template&id=97d823b4&"
import script from "./ReportsTabInvoices.vue?vue&type=script&lang=js&"
export * from "./ReportsTabInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports